import React from 'react';

import Typography from 'kingpin/atoms/Typography';
import InfoBanner from '../../../../../../components/InfoBanner';

const CreateWarning = () => (
  <InfoBanner>
    <Typography.Body type="Body 12">
      Selecting ‘Create Dataset’ will begin processing data, Please note that
      viewing/editing the dataset will be disabled until the processing is
      complete.
    </Typography.Body>
    <br />
    <Typography.Body type="Body 12">Est. Time 30m</Typography.Body>
  </InfoBanner>
);

export default CreateWarning;
